export const environment = {
  envName: '',
  production: true,
  firebase: {},
  
  tenants: [
    {
      tenant: "",
      name: "",
      primaryColor: "",
      overPrimary: "",
      sideMenuColor: {
        up: "",
        down: "",
        text: ""
      },
      apiKey: "",
      client: "",
      clientSuite: true,
      infoHeader: false,
      biz: false,
      apiUrl: '',
      formattedName: "",
      icon: "",
      logo: "",
      orderSupport: false,
      useLocalConfig: false,
      useLocalColors: true,
    }
  ],
  apiUrl: '',
  keyEncryptAuth: '',
  account: ' ',
  branch: ' ',
  wallet: ' ',
  bank: ' ',
  currency: ' ',
  custom: {
    login: false
  }
}